module.exports = __webpack_public_path__ + "static/media/hist-blackface.0b3adb31.png";